/**
 * 池长路由
 */
const AdminRouter = {
  path: 'admin',
  name: 'Admin',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Admin/index')
}
export default AdminRouter
